

  // This file was autogenerated by dynamically running setEnv.ts
  import { EnvironmentVariables } from './environment-variables';

  export const environment: EnvironmentVariables = {
    PIPELINE_STAGE: 'stage'
  };

